(() => {
  const DESKTOP = window.matchMedia('(min-width: 1150px)');
  const CLOSE_DELAY = 150;
  const timers = new WeakMap();

  function clearClose(details) {
    const timer = timers.get(details);
    if (timer) {
      clearTimeout(timer);
      timers.delete(details);
    }
  }

  function closeBranch(details) {
    details.querySelectorAll('details[open]').forEach(child => child.removeAttribute('open'));
    details.removeAttribute('open');
  }

  function bind(details) {
    if (details.dataset.reviveCascadeBound === 'true') return;
    details.dataset.reviveCascadeBound = 'true';

    details.addEventListener('pointerenter', () => {
      if (!DESKTOP.matches) return;
      clearClose(details);

      const parentList = details.closest('ul, .contents');
      if (parentList) {
        parentList.querySelectorAll(':scope > li > details[open]').forEach(sibling => {
          if (sibling !== details) closeBranch(sibling);
        });
      }

      details.setAttribute('open', '');
    });

    details.addEventListener('pointerleave', () => {
      if (!DESKTOP.matches) return;
      clearClose(details);
      const timer = setTimeout(() => closeBranch(details), CLOSE_DELAY);
      timers.set(details, timer);
    });
  }

  function init(root = document) {
    root.querySelectorAll('.shopify-section--header .header__link-list details[is="dropdown-disclosure"]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', event => init(event.target));

  DESKTOP.addEventListener?.('change', event => {
    if (!event.matches) {
      document.querySelectorAll('.shopify-section--header .header__link-list details[open]').forEach(details => details.removeAttribute('open'));
    }
  });
})();
